import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDqdutIyOTmiNdpJN1gr6-fr2aWUyhyma8",
  authDomain: "enteeon.firebaseapp.com",
  projectId: "enteeon",
  storageBucket: "enteeon.firebasestorage.app",
  messagingSenderId: "253907305582",
  appId: "1:253907305582:web:efae38ff8141327689927f",
  measurementId: "G-67VXJER1ZM"
};

// Log all Firebase config values for debugging
console.log('Firebase Config:', {
  apiKey: firebaseConfig.apiKey ? '***' + firebaseConfig.apiKey.slice(-4) : 'undefined',
  authDomain: firebaseConfig.authDomain,
  projectId: firebaseConfig.projectId,
  storageBucket: firebaseConfig.storageBucket,
  messagingSenderId: firebaseConfig.messagingSenderId,
  appId: firebaseConfig.appId,
  measurementId: firebaseConfig.measurementId
});

// Additional debug logs for environment variables
console.log('Environment Variables Check:');
console.log('REACT_APP_FIREBASE_API_KEY:', process.env.REACT_APP_FIREBASE_API_KEY ? '***' + process.env.REACT_APP_FIREBASE_API_KEY.slice(-4) : 'undefined');
console.log('REACT_APP_FIREBASE_AUTH_DOMAIN:', process.env.REACT_APP_FIREBASE_AUTH_DOMAIN);
console.log('REACT_APP_FIREBASE_PROJECT_ID:', process.env.REACT_APP_FIREBASE_PROJECT_ID);

// Initialize Firebase
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Conditionally initialize analytics
let analytics = null;
export const initializeFirebaseAnalytics = () => {
  if (!analytics) {
    analytics = getAnalytics(app);
    // Disable automatic page view tracking in Firebase Analytics
    if (window.gtag) {
      window.gtag('config', firebaseConfig.measurementId, { send_page_view: false });
    }
  }
  return analytics;
};

export { analytics };